// "Why it matters" line. Editor-written lines show as-is; AI-generated lines
// always carry an "AI-generated" tag (never presented as a Databricks or
// editor statement). Excerpt-only stories without a line show nothing.
import { whyKind, type Story } from "../../shared/model.ts";

export function AiTag({ model }: { model?: string | null }) {
  return (
    <span
      className="ml-1.5 inline-flex items-center rounded-md border border-ink/25 px-1.5 align-[1px] text-2xs font-semibold uppercase tracking-wide text-ink-soft"
      title={`Written by AI${model ? ` (${model})` : ""} from the official text. It can be wrong and isn't a Databricks statement; check the source.`}
    >
      AI-generated
    </span>
  );
}

export function WhyItMatters({ story, variant = "card" }: { story: Pick<Story, "whyItMatters" | "whyProvenance" | "whyModel" | "summaryProvenance">; variant?: "card" | "inline" }) {
  const kind = whyKind(story);
  if (!kind) return null;
  const body = (
    <>
      <strong className="font-semibold text-ink">Why it matters</strong>
      {kind === "ai" && <AiTag model={story.whyModel} />}
      <span>: </span>
      {story.whyItMatters}
      {kind === "ai" && <span className="sr-only"> (AI-generated; can be wrong)</span>}
    </>
  );
  return variant === "card" ? (
    <p className="rounded-lg border-l-2 border-ink-soft/50 bg-sand/70 px-3 py-2 text-sm leading-snug text-ink">{body}</p>
  ) : (
    <p className="text-sm leading-snug">{body}</p>
  );
}
